"use strict";
exports.__esModule = true;
exports.RoomStore = void 0;
var akita_1 = require("@datorama/akita");
exports.RoomStore = akita_1.createEntityStore([], { name: 'room', idKey: 'roomId' });
//# sourceMappingURL=room.store.js.map